module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3cac0342b766442b1fbc630983c13950.png";